import script from "./DMSuiteIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./DMSuiteIcon.vue?vue&type=script&setup=true&lang=ts"

import "./DMSuiteIcon.vue?vue&type=style&index=0&id=fcc4dca6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fcc4dca6"]])

export default __exports__